var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import "@frameworks/pmsjourney/pages/Features/OrderBook/orderbook.scss";
import "./lobApproval.scss";
// components
import SearchPanelWithPopupFiltersLabel from "@frameworks/pmsjourney/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import LobApprovalTable from "./components/LobTable";
import OrderSuccess from "./components/OrderSuccess";
import OrderReject from "./components/OrderReject";
import MFOrderbookCalendarFilter from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/common/MFOrderbookCalendarFilter/MFOrderbookCalendarFilter";
import ExcelPdfDownload from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/common/ExcelPdfDownload/ExcelPdfDownload";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { downloadExcelFile } from "@domains/utils/downloadExcelFile";
import generateTableColumns from "./tableColumns";
import { useCheckboxHandler } from "./hooks/useCheckBoxHandler";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { accountDetails } from "@mainDi/salesDi";
var LobApprovalPage = function (_a) {
    var _b, _c, _d, _e;
    var subCategoryId = _a.subCategoryId;
    //
    var _f = __read(useState(false), 2), showSuccess = _f[0], setShowSuccess = _f[1];
    var _g = __read(useState(false), 2), showReject = _g[0], setShowReject = _g[1];
    var _h = __read(useState({
        approve: false,
        reject: false,
    }), 2), loading = _h[0], setLoading = _h[1];
    var _j = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), toastDetails = _j[0], setToastDetails = _j[1];
    var _k = __read(useState(""), 2), reason = _k[0], setReason = _k[1];
    var _l = __read(useState(false), 2), excelDownloadLoader = _l[0], setExcelDownloadLoader = _l[1];
    var _m = __read(useState(false), 2), isShowExportPopup = _m[0], setIsShowExportPopup = _m[1];
    var _o = __read(useState({ label: "", value: "" }), 2), selectedValue = _o[0], setSelectedValue = _o[1];
    var _p = __read(useState({
        message: "",
        type: "approve",
    }), 2), successModalData = _p[0], setSuccessModalData = _p[1];
    var _q = __read(useState(""), 2), searchText = _q[0], setSearchText = _q[1];
    var ref = useRef(null);
    var initialRequestPayload = {
        categoryCode: subCategoryId,
        fromDate: null,
        toDate: null,
        myTeamQc: false,
        searchKey: "",
        pageIndex: 1,
        pageSize: 10,
        orderByDesc: true,
        orderBy: "",
        approvalType: "L2",
        trxId: null,
    };
    var _r = __read(useState(initialRequestPayload), 2), requestPayload = _r[0], setRequestPayload = _r[1];
    var _s = __read(useState(true), 2), isShowMandatesShimmer = _s[0], setIsShowMandatesShimmer = _s[1];
    var _t = __read(useState(false), 2), openSBViewDetails = _t[0], setOpenSBViewDetails = _t[1];
    var _u = __read(useState(false), 2), isShowFilterPopup = _u[0], setIsShowFilterPopup = _u[1];
    var _v = __read(useState(null), 2), orderBookList = _v[0], setOrderBookList = _v[1];
    var _w = useCheckboxHandler((_c = (_b = orderBookList === null || orderBookList === void 0 ? void 0 : orderBookList.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
        return {
            trxId: item.trxId,
        };
    })) !== null && _c !== void 0 ? _c : []), checked = _w.checked, handleCheck = _w.handleCheck, handleSelectAll = _w.handleSelectAll, resetSelection = _w.resetSelection;
    var removeEmptyObjects = function (obj) {
        if (Array.isArray(obj)) {
            return obj.length === 0 ? undefined : obj.map(removeEmptyObjects);
        }
        if (obj && typeof obj === "object") {
            var cleanedObj = {};
            for (var key in obj) {
                var cleanedValue = removeEmptyObjects(obj[key]);
                if (cleanedValue !== undefined && cleanedValue !== null) {
                    cleanedObj[key] = cleanedValue;
                }
            }
            return Object.keys(cleanedObj).length === 0 ? undefined : cleanedObj;
        }
        return obj;
    };
    var handleCancelApplyingFilters = function (isShowPopup) {
        if (isShowPopup === void 0) { isShowPopup = false; }
        setIsShowFilterPopup(isShowPopup);
    };
    var handleApplySearch = function (text) {
        if (text) {
            var localFilterData_1 = __assign(__assign({}, requestPayload), { searchKey: text });
            setIsShowMandatesShimmer(true);
            var orderbooklist = function () { return __awaiter(void 0, void 0, void 0, function () {
                var data, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, aifPmsDi.qualityCheck.pendingTransactions(localFilterData_1)];
                        case 1:
                            data = _a.sent();
                            setOrderBookList(data);
                            setIsShowMandatesShimmer(false);
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            setIsShowMandatesShimmer(false);
                            console.log(err_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            orderbooklist();
        }
        else {
            var localFilterData_2 = __assign({}, requestPayload);
            delete localFilterData_2.searchKey;
            setIsShowMandatesShimmer(true);
            var orderbooklist = function () { return __awaiter(void 0, void 0, void 0, function () {
                var data, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, aifPmsDi.qualityCheck.pendingTransactions(localFilterData_2)];
                        case 1:
                            data = _a.sent();
                            setOrderBookList(data);
                            setIsShowMandatesShimmer(false);
                            return [3 /*break*/, 3];
                        case 2:
                            err_2 = _a.sent();
                            setIsShowMandatesShimmer(false);
                            console.log(err_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            orderbooklist();
        }
    };
    useEffect(function () {
        if (subCategoryId) {
            fetchLobApprovalData();
        }
    }, [requestPayload, subCategoryId]);
    var fetchLobApprovalData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setIsShowMandatesShimmer(true);
                    return [4 /*yield*/, aifPmsDi.qualityCheck.pendingTransactions(requestPayload)];
                case 1:
                    data = _a.sent();
                    setOrderBookList(data);
                    setIsShowMandatesShimmer(false);
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    setIsShowMandatesShimmer(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var clearSearching = function () {
        setRequestPayload(initialRequestPayload);
    };
    var onClickReject = function () {
        setShowReject(true);
    };
    var onClickApprove = function () {
        var _a;
        setLoading(function (prev) { return (__assign(__assign({}, prev), { approve: true })); });
        aifPmsDi.qualityCheck
            .updateApproveRejectStatus({
            trxId: (_a = checked === null || checked === void 0 ? void 0 : checked.map(function (item) { return item.trxId; })) !== null && _a !== void 0 ? _a : [],
            approver: "L2",
            approverCode: "",
            trxStatus: "approve",
        })
            .then(function (response) {
            setLoading(function (prev) { return (__assign(__assign({}, prev), { approve: false })); });
            if (response.data) {
                fetchLobApprovalData();
                setShowSuccess(true);
                setSuccessModalData({
                    message: "".concat(checked.length, " Orders Approved Successfully"),
                    type: "approve",
                });
            }
        })
            .catch(function (error) {
            setLoading(function (prev) { return (__assign(__assign({}, prev), { approve: false })); });
        });
    };
    var onClickCancel = function () {
        setSelectedValue({ label: "", value: "" });
        setShowReject(false);
    };
    var onClickSuccessCancel = function () {
        setShowSuccess(false);
        resetSelection();
    };
    var onClickSubmit = function () {
        var _a;
        setLoading(function (prev) { return (__assign(__assign({}, prev), { reject: true })); });
        aifPmsDi.qualityCheck
            .updateApproveRejectStatus({
            trxId: (_a = checked === null || checked === void 0 ? void 0 : checked.map(function (item) { return item.trxId; })) !== null && _a !== void 0 ? _a : [],
            approver: "L2",
            approverCode: "",
            trxStatus: "reject",
            rejectionReason: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value,
            rejectionRemark: reason,
        })
            .then(function (response) {
            setLoading(function (prev) { return (__assign(__assign({}, prev), { reject: false })); });
            if (response.data) {
                fetchLobApprovalData();
                setShowReject(false);
                setSuccessModalData({
                    message: "".concat(checked.length, " Orders Rejected Successfully"),
                    type: "reject",
                });
                setShowSuccess(true);
            }
        })
            .catch(function (error) {
            setLoading(function (prev) { return (__assign(__assign({}, prev), { reject: false })); });
        });
    };
    var handleUpdatePmsFiltersData = function (data) {
        var filtersObject = __assign(__assign({}, requestPayload), { fromDate: String(data.fromDate), toDate: String(data.toDate) });
        if (searchText) {
            filtersObject.searchKey = searchText;
        }
        else {
            delete filtersObject.searchKey;
        }
        setRequestPayload(filtersObject);
    };
    var handleDownloadExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginCode, isDownloadSuccessful, fileName, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setExcelDownloadLoader(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 2:
                    loginCode = _a.sent();
                    return [4 /*yield*/, aifPmsDi.qualityCheck.downloadPendingTransaction(__assign(__assign({}, requestPayload), { loginBy: loginCode }))];
                case 3:
                    isDownloadSuccessful = _a.sent();
                    fileName = subCategoryId === Number(ESubProductIds.AIF)
                        ? "AIF_Pending_Transactions.xls"
                        : "PMS_Pending_Transactions.xls";
                    if (isDownloadSuccessful && (isDownloadSuccessful === null || isDownloadSuccessful === void 0 ? void 0 : isDownloadSuccessful.data)) {
                        downloadExcelFile(isDownloadSuccessful === null || isDownloadSuccessful === void 0 ? void 0 : isDownloadSuccessful.data, fileName);
                        setToastDetails({
                            isShow: true,
                            isError: false,
                            msg: "Excel file downloaded successfully!",
                        });
                    }
                    else {
                        setToastDetails({
                            isShow: true,
                            isError: true,
                            msg: "Failed to download excel file!",
                        });
                    }
                    setExcelDownloadLoader(false);
                    return [3 /*break*/, 5];
                case 4:
                    err_4 = _a.sent();
                    setExcelDownloadLoader(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "position-relative primary-mutual-fund-order-container d-flex flex-column gap-20 order-book-ap otc-order-book-table", ref: ref },
            React.createElement("div", { className: "header-title" },
                React.createElement("div", { className: "txt-midnight-blue DMSansM_24_500" }, "Select Entries for Approving or Rejecting the order")),
            React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "order-book-filter-ap", searchBarParentClassName: "w-400", isShowPopup: isShowFilterPopup, setIsShowPopup: handleCancelApplyingFilters, showFilter: false, searchValue: requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.searchKey, applySearchedFilters: function (text) {
                    handleApplySearch(text);
                    setSearchText(text);
                }, clearSearching: clearSearching, placeholder: "Search by issuer name, type or status", iconClassName: "edel-icon-curved-filter", delay: 800, isFilterHeader: false, filterLabels: [], rightSubComponent: React.createElement(React.Fragment, null,
                    React.createElement(MFOrderbookCalendarFilter, { filtersData: {
                            fromDate: requestPayload.fromDate,
                            toDate: requestPayload.toDate,
                        }, handleApplyCallback: function () { }, handleFilterChangeCallback: handleUpdatePmsFiltersData }),
                    React.createElement(ExcelPdfDownload, { excelDownloadLoader: excelDownloadLoader, handleExcelDownloadCallback: handleDownloadExcel, isShowExportPopup: isShowExportPopup, setIsShowExportPopup: setIsShowExportPopup })) }),
            React.createElement(LobApprovalTable, { tableData: (_d = orderBookList === null || orderBookList === void 0 ? void 0 : orderBookList.data) !== null && _d !== void 0 ? _d : [], tableColumns: generateTableColumns({
                    id: "aif-pms",
                    subCategoryId: subCategoryId,
                    checked: checked,
                    handleCheck: handleCheck,
                    handleSelectAll: handleSelectAll,
                    data: (_e = orderBookList === null || orderBookList === void 0 ? void 0 : orderBookList.data) !== null && _e !== void 0 ? _e : [],
                }), openSB: openSBViewDetails, viewAllOnClick: function () { }, showShimmer: isShowMandatesShimmer, showViewAll: false, setOpenSB: setOpenSBViewDetails, defaultSortingColumnKey: "scheme_name", subCategoryId: subCategoryId, selectedSortColumnVal: requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.orderBy, selectedSortVal: (requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.orderByDesc) ? "DESC" : "ASC", callbackSorted: function (value) {
                    setRequestPayload(__assign(__assign({}, requestPayload), { orderBy: value === null || value === void 0 ? void 0 : value.sortKey, orderByDesc: !requestPayload.orderByDesc }));
                }, errorScreenMessage: "" })),
        React.createElement("div", { className: "lob-footer" },
            React.createElement(EdButton, { disabled: (checked === null || checked === void 0 ? void 0 : checked.length) == 0, onClick: onClickReject, btnTyp: "link", value: "Reject", className: "reject-button" }),
            loading.approve ? (React.createElement("div", { className: "d-flex justify-content-center" },
                React.createElement(Spinner, { animation: "border" }))) : (React.createElement(EdButton, { onClick: onClickApprove, btnTyp: (checked === null || checked === void 0 ? void 0 : checked.length) == 0 ? "midnight-blue" : "tomato", value: "Approve", className: "approve-button rounded-pill", disabled: (checked === null || checked === void 0 ? void 0 : checked.length) == 0 }))),
        React.createElement(OrderSuccess, { show: showSuccess, setShow: setShowSuccess, onClickCancel: onClickSuccessCancel, title: successModalData.message, type: successModalData.type }),
        React.createElement(OrderReject, { loading: loading.reject, show: showReject, setShow: setShowReject, reason: reason, setReason: setReason, selectedValue: selectedValue, setSelectedValue: setSelectedValue, onClickCancel: onClickCancel, onClickSubmit: onClickSubmit }),
        React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                toastDetails.isError ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                React.createElement("span", null, toastDetails.msg)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: toastDetails.isShow, setClose: function () {
                setToastDetails({ isShow: false, isError: false, msg: "" });
            }, autohide: true, parentClassName: "product-bouquet-toast" })));
};
export default LobApprovalPage;
